import React, { useState } from 'react';
import { adminAuthAPI } from '../api';

export default function Settings() {
  const [form, setForm]       = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState(false);

  const set = (k) => (e) => { setForm(f => ({ ...f, [k]: e.target.value })); setError(''); setSuccess(false); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess(false);
    if (form.newPassword !== form.confirmPassword) { setError('New passwords do not match'); return; }
    if (form.newPassword.length < 12) { setError('New password must be at least 12 characters'); return; }
    if (!/[a-z]/.test(form.newPassword) || !/[A-Z]/.test(form.newPassword) || !/[0-9]/.test(form.newPassword)) {
      setError('New password must include lowercase, uppercase, and a number'); return;
    }
    setSaving(true);
    try {
      await adminAuthAPI.changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      setSuccess(true);
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1>Settings</h1>
      <div style={{ maxWidth: 420, background: '#1e293b', border: '1px solid #334155', borderRadius: 8, padding: '1.5rem' }}>
        <h2 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1.25rem', color: '#e2e8f0' }}>Change Password</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Current password</label>
            <input type="password" value={form.currentPassword} onChange={set('currentPassword')} required autoComplete="current-password" />
          </div>
          <div className="form-group">
            <label>New password</label>
            <input type="password" value={form.newPassword} onChange={set('newPassword')} required autoComplete="new-password" minLength={12} />
          </div>
          <div className="form-group">
            <label>Confirm new password</label>
            <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} required autoComplete="new-password" minLength={12} />
          </div>
          {error   && <p style={{ color: '#ef4444', fontSize: '0.82rem', marginBottom: '0.75rem' }}>{error}</p>}
          {success && <p style={{ color: '#22c55e', fontSize: '0.82rem', marginBottom: '0.75rem' }}>Password updated successfully.</p>}
          <button type="submit" className="btn-primary" disabled={saving} style={{ width: '100%' }}>
            {saving ? 'Updating…' : 'Update password'}
          </button>
        </form>
      </div>
    </div>
  );
}
